import React, { useState,useEffect } from 'react';
import {SidebarContainer,
    Icon,
    CloseIcon,
    SidebarWrapper,
    SidebarLink,
    SideBtnWrap,
    SidebarRoute,
    SidebarMenu,ProfileTof,UserBox} from './SidebarElements';

    import { Nav,
        NavbarContainer,
        NavbarContainer2,
        NavLogo,
        MobileIcon,
        NavMenu,
        NavItem,
        NavLinks,
        NavBtn,
        NavBtnLink, 
        NavLinksAbout} from '../Navbar/NavbarElements';
    

    import {useDispatch } from 'react-redux';
    import {useNavigate} from 'react-router-dom';
    import seal from '../../images/classic rooms/classic1.jpg'

    import UserBar from '../UserBar';

import './SideBar.css';



const Sidebar = ({isOpen,toggle}) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [user,setUser]= useState(JSON.parse(localStorage.getItem('profile')));
    
    const logout = ()=>{
        dispatch({type: 'LOGOUT'});
        navigate('/');
        setUser(null)
    }

    useEffect(()=>{
        const token = user?.token;
        // jwt
       
        setUser(JSON.parse(localStorage.getItem('profile')))
        // window.addEventListener('scroll',changeNav);

    },[])


    return (
        <SidebarContainer isOpen={isOpen} onClick={toggle}>
            <Icon onClick={toggle} >
                <CloseIcon />
            </Icon>
            <SidebarWrapper>
                        {/* <ProfileTof>
                           hello
                            { user ?<UserBar elm={user.result.givenName} img={user.result.imageUrl} />: null}
                        </ProfileTof> */}
                        
                 <SidebarMenu>
                        
                 
                     <SidebarLink to='/#home' onClick={toggle}>
                         Home
                     </SidebarLink>
                     <SidebarLink to='/discover' onClick={toggle}>
                         Rooms
                     </SidebarLink>
                     <SidebarLink to='/amenities' onClick={toggle}>
                         Amenities
                     </SidebarLink>
                     <SidebarLink to='/placestovisit' onClick={toggle}>
                         Places To Visit
                     </SidebarLink>
                     
                     <SidebarLink to='/gallery' onClick={toggle}>
                         Gallery
                     </SidebarLink>
                     
                    
                 </SidebarMenu>
                 <SideBtnWrap>
                 {/* {user?<SidebarRoute to='' onClick={logout}>LOGOUT</SidebarRoute>:<SidebarRoute to='/auth'>LOGIN</SidebarRoute>} */}
                 {/* { user ?<UserBar elm={user.result.givenName} img={user.result.imageUrl} />: null} */}
                 
                 </SideBtnWrap>
                 {user?<SideBtnWrap>
                           <SidebarLink style={{position:'relative',top:'-60px'}} to="/admin/messages">Messages</SidebarLink>
                           
                       </SideBtnWrap>:null
                       }

                 <SideBtnWrap>
                    <a className='ExtLink2' href='https://www.secure-booking-engine.com/accounts/FrmOnne118jtpxNpFLSXTA/properties/hahnewYRURcxpWB0cjHizA/booking-engine/web/source/4wsctBw6Oq6j-g9XuxeRzQ/cart/rvihAtgVBGGfltd7DzgEvQ/#/search'>Book Now</a>
                 </SideBtnWrap>
                 { user ?<UserBox >
                     {/* <ProfileTof src={user.name} alt='img' /> */}
                     {/* <h5>{user.name}</h5> */}
                 </UserBox>: null}
                 
                 
            </SidebarWrapper>
        </SidebarContainer>
    )
}

export default Sidebar
